import vector from "../../assets/icons/Home.svg";
import courses from "../../assets/icons/Courses.svg";
import study from "../../assets/icons/study.svg";

export default [
    {
        id: "home",
        title: "Notes",
        icon: <img src={vector} style={{ marginRight: "15px" }} />,
        navLink: "/home",
    },
    {
        id: "courses",
        title: "Courses",
        icon: <img src={courses} style={{ marginRight: "15px" }} />,
        navLink: "/courses",
    },
    {
        id: "quizLog",
        title: "Quiz Log",
        icon: <img src={study} style={{ marginRight: "15px" }} />,
        navLink: "/quizLog",
    },
];
